import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, JSON.stringify(token))
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function getUserInfo() {
  return Cookies.get('userInfo')
}
export function removeUserInfo() {
  return Cookies.remove('userInfo')
}